/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {adminGetMoneyPool} from '../api'

export const useMutationAdminGetMoneyPool = createReactQueryMutationHook('adminGetMoneyPool', adminGetMoneyPool)
